
define('text!modules/reporting/segments/templates/segment_reports.html',[],function () { return '<div class="w-box w-CreateEditForm w-Reporting">\n\t<div class="w-body reporting-tabs"></div>\n</div>';});

